// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-language-switcher[data-v-5def12ec]{cursor:pointer;text-align:center;line-height:1;font-size:13px!important;width:32px;height:32px!important;min-height:auto;border-radius:6px}", ""]);
// Exports
module.exports = exports;
